import React from 'react';
import { ModalForm, AfterSubmitProps, FormFieldsData } from 'framework/form';
import { useDocumentStorageContext } from 'framework/documentStorage';
import ComplianceDocumentForm from 'domain/compliance/complianceRegistry/createupdate/ComplianceDocumentForm';
import { ComplianceDocumentTypeFE } from 'domain/shared/compliance';
import { useShowContext } from 'framework/show';

const EditComplianceDocumentAction = ({
  modalOpen,
  closeModal,
  afterSubmit,
}: {
  modalOpen: boolean;
  closeModal: () => void;
  afterSubmit: AfterSubmitProps<(response: FormFieldsData) => void>;
}) => {
  const { data } = useShowContext<ComplianceDocumentTypeFE>();
  const { editDocument, getValidationSchema } = useDocumentStorageContext();

  const documentData = data.getData();

  return (
    <ModalForm
      getValidationSchemaFunc={getValidationSchema}
      modalOpen={modalOpen}
      closeModal={closeModal}
      handleDirty
      submitFormFunc={editDocument}
      afterSubmit={{
        ...afterSubmit,
      }}
      initialData={{
        isPolicySigned: documentData?.isPolicySigned,
        ...documentData.metadata,
        paths: [documentData.path],
      }}
      isHideDefaultButtons
    >
      <ComplianceDocumentForm isEditForm />
    </ModalForm>
  );
};

export default EditComplianceDocumentAction;
